export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-Swift-Objective-C_section_01-1d30285c6e5e67a5d467cbfc93943054.jpg";